module.exports = __webpack_public_path__ + "img/right-arrow.e04df8c8.svg";